import React, { ReactNode } from 'react';

import { Control, useWatch } from 'react-hook-form';

import { LbInput, LbSelect } from '@infoods/lifebase-ui';

import classes from './InbodyInfoForm.module.scss';
import { InputBox, ReadOnlyInput } from '../../../../shared/components/form-components';
import {
  INBODY_TYPES,
  inbodyTypeOptions,
} from '../../../../shared/constants/inbody-info/InbodyType';
import { CombinedCustomerInfo } from '../../../interfaces/Customer';
import { Option } from '../../../../general-types';
import { CustomerProfileFormMode } from '../CustomerProfileForm.settings';

type GeneralDataFromProps = {
  mode: CustomerProfileFormMode;
  control: Control<CombinedCustomerInfo>;
  supportedInbodyTypeOptions?: Option[];
  children: ReactNode;
};

const InbodyInfoForm = ({
  mode,
  control,
  supportedInbodyTypeOptions = [],
  children,
}: GeneralDataFromProps) => {
  const generalInputProps = {
    control,
    size: 'small',
    variant: 'standard',
  } as const;

  const privateInfoProps = { InputProps: { className: 'private-info' } };

  const inbodyType = useWatch({ control, name: 'inbodyInfo.inbodyType' });
  const isInbodyType = inbodyType && inbodyType !== INBODY_TYPES.NON_INBODY;

  const isCreate = mode === 'CREATE';

  return (
    <InputBox title="InBody Info">
      {isCreate ? (
        <LbSelect
          {...generalInputProps}
          name="inbodyInfo.inbodyType"
          label="InBody Type"
          options={supportedInbodyTypeOptions}
          rules={{ required: 'User Type is required' }}
        />
      ) : (
        <ReadOnlyInput
          control={control}
          name="inbodyInfo.inbodyType"
          label="InBody Type"
          options={inbodyTypeOptions}
        />
      )}
      {isInbodyType && (
        <LbInput
          {...generalInputProps}
          {...privateInfoProps}
          name="inbodyInfo.inbodyId"
          label="InBody ID"
          rules={{
            required: 'InBody ID is required',
            pattern: {
              value: /^\d{10}$/,
              message: 'Must be 10 digits',
            },
          }}
        />
      )}
      {children && <div className={classes.spanAll}>{children}</div>}
    </InputBox>
  );
};

export { InbodyInfoForm };
